const ACCOUNTING_PRINCIPLES_2026_2_CORRECTIONS = {
  '001': { startPeriod: 5, endPeriod: 7, periods: [5, 6, 7] },
  '005': { startPeriod: 1, endPeriod: 3, periods: [1, 2, 3] },
}

/**
 * 포털 원본 정정이 반영되기 전까지 재생성 강좌 데이터에 적용하는 2026-2 공식 정정.
 * 대상 외 필드는 원본 크롤링 값을 그대로 보존한다.
 */
export function applyCourseDataOverrides(courses, { year, semester } = {}) {
  if (year !== 2026 || semester !== 2 || !Array.isArray(courses)) return courses

  return courses.map(course => {
    const correction = course.subjectKey === '07661'
      && course.department === '경영공학대학'
      ? ACCOUNTING_PRINCIPLES_2026_2_CORRECTIONS[course.division]
      : null
    if (!correction) return course

    const schedule = `${course.room}(목${correction.periods.join(',')})`
    return {
      ...course,
      days: ['목'],
      startPeriod: correction.startPeriod,
      endPeriod: correction.endPeriod,
      meetings: [{ day: '목', periods: correction.periods, classroom: course.room }],
      sourceSchedule: schedule,
      source: { ...course.source, schedule },
    }
  })
}
